<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3 class="footer-title">宿迁瀚得教育科技有限公司</h3>
          <p class="footer-description">我司是一家国内领先的智慧图书馆整体解决方案服务商，从事智慧图书馆平台软件研发、硬件生产、销售一体的高新技术企业，公司拥有多项产品软著、检测报告、专利等证书。面向全国中小学图书馆、大专院校图书馆、公共图书馆、企事业单位职工书屋、24小时城市书房等提供专业的智慧图书馆建设解决方案;目前已服务过客户超1000家落地成功案例。</p>
        </div>
        <div class="footer-section">
          <h3 class="footer-title">网站导航</h3>
          <ul class="footer-links">
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/solutions">解决方案</router-link></li>
            <li><router-link to="/products">产品中心</router-link></li>
            <li><router-link to="/cases">案例展示</router-link></li>
            <li><router-link to="/news">最新动态</router-link></li>
            <li><router-link :to="{ path: '/', hash: '#about' }">关于我们</router-link></li>
            <li><router-link :to="{ path: '/', hash: '#contact' }">联系我们</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3 class="footer-title">联系方式</h3>
          <ul class="footer-contact">
            <li>售前：0527-88266855</li>
            <li>售后：0527-88266855-6</li>
            <li>邮箱：772919504@qq.com</li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© {{ year }} Copyright © 宿迁瀚得教育科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">苏ICP备2023024070号-1</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  background: #3b7ec5;
  color: #fcfdff;
  padding: 56px 0 20px;
  border-top: 1px solid #dbe7f5;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 36px;
  margin-bottom: 36px;
}

.footer-section { padding: 0 12px; }
.footer-title { font-size: 17px; margin-bottom: 18px; color: #1e3a8a; font-weight: 600; }
.footer-description { font-size: 14px; line-height: 1.65; color: #e8eaec; margin: 0; text-indent: 2em; }

.footer-links,
.footer-contact { list-style: none; padding: 0; margin: 0; }

.footer-links li,
.footer-contact li { margin-bottom: 10px; }

.footer-links a { color: #fafbfc; font-size: 14px; transition: color 0.2s; }
.footer-links a:hover { color: #f7f7f8; }
/* 底部导航不跟随顶部路由高亮，避免点击顶部菜单后红框区域颜色变化 */
.footer-links a.router-link-active,
.footer-links a.router-link-exact-active { color: #f6f6f7; }

.footer-contact li { color: #f4f5f7; font-size: 14px; }

.footer-bottom {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #dbe7f5;
}

.footer-bottom p { margin: 0; color: #f2f2f3; font-size: 13px; }
</style>
